/* eslint-disable line-comment-position */
/* eslint-disable no-empty-function */
// @flow
import React from 'react';
import { LoadMore } from '@finect/tabular-components/Loading';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { SkeletonLine } from '@finect/tabular-components/Skeleton';
import { BottomAds } from '@finect/tabular-components/Ads';
import { ContentListCard, DashboardMenu } from '../../../components';
import { ArticleOnlyForProfessionalInteractionModal } from '../components';
import { ArticleCardContainer } from './partials';

type Props = {
  simple?: boolean,
  scrollOffset?: number,
  type: 'noticias' | 'en-un-minuto' | 'a-fondo',
  articles: Array<Object>,
  fetching: boolean,
  handleMore: Function,
  user: Object,
  followedTags: Array<string>
};

type State = {
  professionalModal: boolean
};

class ArticlesFeed extends React.Component<Props, State> {
  static defaultProps = {
    simple: false
  };

  state = {
    professionalModal: false
  };

  componentWillUnmount() {
    window && window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    window && window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (typeof document === 'undefined') return;

    if (!document.documentElement) return;

    if (document.documentElement.offsetHeight - window.scrollY - window.innerHeight < Number(this.props.scrollOffset)) {
      if (!this.props.fetching) {
        this.props.handleMore();
      }
    }
  };

  handleProfessionalModalClose = () => {
    this.setState({ professionalModal: false });
  };

  render() {
    const { simple, articles, fetching } = this.props;
    const { type } = this.props;

    if (!articles.length) {
      return (
        <Container>
          <ContainerInner>
            <MainContent noMargin>
              <SkeletonLine style={{ height: '800px', width: '100%' }} />
            </MainContent>
          </ContainerInner>
        </Container>
      );
    }

    const cardsWithAuthor = !['en-un-minuto'].includes(type);

    if (simple) {
      return (
        <div>
          {articles.map(article => (
            <ArticleCardContainer key={article.id}>
              <ContentListCard
                withAuthor={cardsWithAuthor}
                key={article.id}
                withText
                type="article"
                entity={article}
                userSubscriptions={{ tags: this.props.followedTags }}
                userLikes={{}}
                onSubscribe={() => {}}
              />
            </ArticleCardContainer>
          ))}
          <LoadMore loading={fetching}></LoadMore>
        </div>
      );
    }

    return (
      <>
        <ArticleOnlyForProfessionalInteractionModal
          user={this.props.user}
          show={this.state.professionalModal}
          onClose={this.handleProfessionalModalClose}
        />

        <Container fullWidth>
          <ContainerInner>
            <DashboardMenu withPublish={false} onlyContents tags={[]} user={this.props.user} currentSelection={type} />

            <MainContent noMargin>
              <div>
                {articles.map(article => (
                  <ArticleCardContainer key={article.id}>
                    <ContentListCard
                      withAuthor={cardsWithAuthor}
                      key={article.id}
                      withText
                      type="article"
                      entity={article}
                      userSubscriptions={{ tags: this.props.followedTags }}
                      userLikes={{}}
                      onSubscribe={() => {}}
                    />
                  </ArticleCardContainer>
                ))}
                <LoadMore loading={fetching}></LoadMore>
              </div>
            </MainContent>
          </ContainerInner>

          <BottomAds path="Finect_Content_1" sticky closeable />
        </Container>
      </>
    );
  }
}

export default ArticlesFeed;
